import script from "./AdminHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHeader.vue?vue&type=script&setup=true&lang=js"

import "./AdminHeader.vue?vue&type=style&index=0&id=44267a18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44267a18"]])

export default __exports__